import styled from '@emotion/styled';
import { ButtonDesign, ButtonSize, ButtonStyle } from 'components/buttons/ButtonStyle';

export const FindInputBtnSet = styled.div`
  display: flex;
  align-items: center;
  & > div {
    width: 100%;
  }
  & > button {
    margin-left: 4px;
    ${ButtonSize.md}
    ${ButtonStyle.outlineNormal}
    ${ButtonDesign.IconMD}
  }
`;

export const TextBtnSet = styled.div`
  display: flex;
  align-items: center;
  & > button {
    margin-left: 4px;
    ${ButtonSize.md}
    ${ButtonStyle.unOutlineNormal}
    ${ButtonDesign.IconMD}
  }
`;
